import { CoreModule } from '@abp/ng.core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { ChangeVendorModalComponent } from './components/change-vendor-modal/change-vendor-modal.component';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { SelectModule } from 'primeng/select';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { FluidModule } from 'primeng/fluid';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MultiSelect } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { SliderModule } from 'primeng/slider';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { DatePicker } from 'primeng/datepicker';
import { CurrentVendorDescriptionComponent } from './components/current-vendor-description/current-vendor-description.component';
import { SmartInvoicingBreadcrumbComponent } from './components/smart-invoicing-breadcrumb/smart-invoicing-breadcrumb.component';
import { CreateButtonComponent } from './components/create-button/create-button.component';
import { EditIconButtonComponent } from './components/edit-icon-button/edit-icon-button.component';
import { DeleteIconButtonComponent } from './components/delete-icon-button/delete-icon-button.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { LabelContentComponent } from './components/label-content/label-content.component';
import { BasicCardFooterComponent } from './components/basic-card-footer/basic-card-footer.component';
import { ActiveInactiveTagComponent } from './components/active-inactive-tag/active-inactive-tag.component';
import { FilterIconButtonComponent } from './components/filter-icon-button/filter-icon-button.component';
import { ExternalSystemStateDropdownComponent } from './components/external-system-state-dropdown/external-system-state-dropdown.component';
import { PlaceSelectorComponent } from './components/place-selector/place-selector.component';
import { Checkbox } from 'primeng/checkbox';
import { ProviderStateDropdownComponent } from './components/provider-state-dropdown/provider-state-dropdown.component';
import { UserAutocompleteComponent } from './components/user-autocomplete/user-autocomplete.component';
import { ProviderAutocompleteComponent } from './components/provider-autocomplete/provider-autocomplete.component';
import { ServiceConfigurationStateDropdownComponent } from './components/service-number-configuration-state-dropdown/service-configuration-state-dropdown.component';
import { VendorAutocompleteComponent } from './components/vendor-autocomplete/vendor-autocomplete.component';
import { VendorSelectorComponent } from './components/vendor-selector/vendor-selector.component';
import { ServiceSelectorComponent } from './components/service-selector/service-selector.component';
import { RoleAutocompleteComponent } from './components/role-autocomplete/role-autocomplete.component';
import { PeriodStateDropdownComponent } from './components/period-state-dropdown/period-state-dropdown.component';
import { ServiceAutocompleteComponent } from './components/service-autocomplete/service-autocomplete.component';
import { PeriodSelectorComponent } from './components/period-selector/period-selector.component';
import { ViewIconButtonComponent } from './components/view-icon-button/view-icon-button.component';
import { ExternalSystemSelectorComponent } from './components/external-system-selector/external-system-selector.component';
import { TabsModule } from 'primeng/tabs';
import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { SystemBadgeComponent } from './components/system-badge/system-badge.component';
import { TextareaModule } from 'primeng/textarea';
import { ServiceEntrySheetStateDropdownComponent } from './components/service-entry-sheet-state-dropdown/service-entry-sheet-state-dropdown.componente';
import { ServiceEntrySheetStateTagComponent } from './components/service-entry-sheet-state-tag/service-entry-sheet-state-tag.component';
import { RevertIconButtonComponent } from './components/revert-icon-button/revert-icon-button.component';
import { CardModule } from 'primeng/card';
import { IntegrationStateIconComponent } from './components/integration-state-icon/integration-state-icon.component';
import { ExportButtonComponent } from './components/export-button/export-button.component';
import { OperationDropdownComponent } from './components/operation-dropdown/operation-dropdown.component';
import { IntegrationStateDropdownComponent } from './components/integration-state-dropdown/integration-state-dropdown.component';
import { ExecuteIconButtonComponent } from './components/execute-icon-button/execute-icon-button.component';
import { ClearFilterButtonComponent } from './components/clear-filter-button/clear-filter-button.component';
import { ServiceTypeSelectorComponent } from './components/service-type-selector/service-type-selector.component';
import { ExternalSystemMultiselectorComponent } from './components/external-system-multiselector/external-system-multiselector.component';
import { ServiceTagComponent } from './components/service-tag/service-tag.component';

@NgModule({
  declarations: [
    ChangeVendorModalComponent,
    CurrentVendorDescriptionComponent,
    SmartInvoicingBreadcrumbComponent,
    CreateButtonComponent,
    EditIconButtonComponent,
    DeleteIconButtonComponent,
    BackButtonComponent,
    LabelContentComponent,
    BasicCardFooterComponent,
    ActiveInactiveTagComponent,
    FilterIconButtonComponent,
    ExternalSystemStateDropdownComponent,
    PlaceSelectorComponent,
    ProviderStateDropdownComponent,
    UserAutocompleteComponent,
    ProviderAutocompleteComponent,
    ServiceConfigurationStateDropdownComponent,
    ServiceAutocompleteComponent,
    VendorAutocompleteComponent,
    VendorSelectorComponent,
    ServiceSelectorComponent,
    PeriodSelectorComponent,
    ViewIconButtonComponent,
    RoleAutocompleteComponent,
    PeriodStateDropdownComponent,
    ServiceEntrySheetStateDropdownComponent,
    ExternalSystemSelectorComponent,
    SystemBadgeComponent,
    ServiceEntrySheetStateTagComponent,
    RevertIconButtonComponent,
    IntegrationStateIconComponent,
    ExportButtonComponent,
    OperationDropdownComponent,
    IntegrationStateDropdownComponent,
    ExecuteIconButtonComponent,
    ServiceTypeSelectorComponent,
    ClearFilterButtonComponent,
    ExternalSystemMultiselectorComponent,
    ServiceTagComponent,
  ],
  imports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    ButtonModule,
    TooltipModule,
    DialogModule,
    TagModule,
    FloatLabelModule,
    SelectModule,
    AutoCompleteModule,
    FluidModule,
    ToggleSwitchModule,
    MultiSelect,
    InputTextModule,
    InputNumberModule,
    SliderModule,
    PaginatorModule,
    TableModule,
    DatePicker,
    Checkbox,
    TabsModule,
    BadgeModule,
    OverlayBadgeModule,
    TextareaModule,
    CardModule,
  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    ChangeVendorModalComponent,
    CurrentVendorDescriptionComponent,
    SmartInvoicingBreadcrumbComponent,
    ButtonModule,
    TooltipModule,
    DialogModule,
    TagModule,
    FloatLabelModule,
    SelectModule,
    AutoCompleteModule,
    FluidModule,
    ToggleSwitchModule,
    MultiSelect,
    InputTextModule,
    InputNumberModule,
    SliderModule,
    PaginatorModule,
    TableModule,
    DatePicker,
    CreateButtonComponent,
    EditIconButtonComponent,
    DeleteIconButtonComponent,
    BackButtonComponent,
    LabelContentComponent,
    BasicCardFooterComponent,
    ActiveInactiveTagComponent,
    FilterIconButtonComponent,
    ExternalSystemStateDropdownComponent,
    PlaceSelectorComponent,
    Checkbox,
    ProviderStateDropdownComponent,
    UserAutocompleteComponent,
    ProviderAutocompleteComponent,
    ServiceConfigurationStateDropdownComponent,
    ServiceAutocompleteComponent,
    VendorAutocompleteComponent,
    VendorSelectorComponent,
    ServiceSelectorComponent,
    PeriodSelectorComponent,
    ViewIconButtonComponent,
    RoleAutocompleteComponent,
    PeriodStateDropdownComponent,
    ExternalSystemSelectorComponent,
    TabsModule,
    BadgeModule,
    OverlayBadgeModule,
    SystemBadgeComponent,
    TextareaModule,
    ServiceEntrySheetStateDropdownComponent,
    ServiceEntrySheetStateTagComponent,
    RevertIconButtonComponent,
    CardModule,
    IntegrationStateIconComponent,
    ExportButtonComponent,
    OperationDropdownComponent,
    IntegrationStateDropdownComponent,
    ExecuteIconButtonComponent,
    ServiceTypeSelectorComponent,
    ClearFilterButtonComponent,
    ExternalSystemMultiselectorComponent,
    ServiceTagComponent,
  ],
  providers: [],
})
export class SharedModule {}
